import { isIOS } from '@hotelplan/libs.utils';
import { FdrCoordinates } from '@hotelplan/supergraph-api';

export function getLocationLink(coord: FdrCoordinates): string {
  const { latitude, longitude } = coord;

  return isIOS
    ? `https://maps.apple.com/?daddr=${latitude},${longitude}`
    : `https://www.google.com/maps/dir/?api=1&destination=${latitude}%2C${longitude}`;
}

export function mapPhoneToTelLink(phone: string): string {
  if (!phone.startsWith('+')) return phone;
  return `tel:${phone}`;
}
